import CompanyDataCard from '../../CompanyDataCard';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import React from 'react';
import TableColumnDate from '../../TableColumnDate';
import { IdcardOutlined } from '@ant-design/icons';
import ProfTable from '../../ProfTable';

const JarActivities = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('professionalReport.basicData.jarActivities.registrationDate'),
      dataIndex: 'registrationDate',
      key: 'registrationDate',
      render: TableColumnDate,
      sorter: (a, b) => {
        const dateA = new Date(a.dateFrom);
        const dateB = new Date(b.dateFrom);
        return dateB - dateA;
      },
    },
    {
      title: t('professionalReport.basicData.jarActivities.description'),
      dataIndex: 'description',
      key: 'description',
      sortDirections: ['ascend', 'descend'],
    },
  ];
  if (!data || data.length === 0) return null;

  return (
    <CompanyDataCard title={t('professionalReport.basicData.jarActivities.title')} icon={<IdcardOutlined />}>
      <Row>
        <Col span={24}>
          <ProfTable
            rowKey={record => record.year}
            bordered
            dataSource={data}
            columns={columns}
            scroll={{ x: 'max-content' }}
            pagination={false}
          />
        </Col>
      </Row>
    </CompanyDataCard>
  );
};

export default JarActivities;
